exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Modal-module__wrapper___3fhvK{position:absolute;z-index:100;width:100%;height:100%;top:0;left:0}.Modal-module__wrapper___3fhvK .Modal-module__content___58tDK{position:absolute;z-index:101;top:50%;left:50%;transform:translate(-50%,-50%);width:725px;max-width:80%;background-color:#fff;padding:1rem;border-radius:10px}.Modal-module__wrapper___3fhvK .Modal-module__shader___3EKpT{position:fixed;top:0;left:0;z-index:100;width:100%;height:100%;opacity:.9;background-color:#181818}", ""]);

// exports
exports.locals = {
	"wrapper": "Modal-module__wrapper___3fhvK",
	"content": "Modal-module__content___58tDK",
	"shader": "Modal-module__shader___3EKpT"
};